import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'nggc-tip-filter',
  standalone: true,
  imports: [FormsModule],
  template: `
    <div class="lib-tip-filter">
      <div>Select Tip Range</div>
      <label>
        <input type="radio" name="year" [(ngModel)]="tip" (ngModelChange)="updateFilter()" [value]="-1" />
        All
      </label>
      <label>
        <input type="radio" name="year" [(ngModel)]="tip" (ngModelChange)="updateFilter()" [value]="0" />
        Only With Tips
      </label>
    </div>
  `,
})
export class TipFilterComponent implements IFilterAngularComp {
  params!: IFilterParams;
  tip = -1;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public agInit(params: any): void {
    this.params = params;
  }

  public isFilterActive(): boolean {
    return this.tip === 0;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public doesFilterPass(params: any): boolean {
    return params.data.selectedTip >= 0;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.tip };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
  public setModel(model: any) {
    this.tip = model == null ? null : model.value;
  }

  public updateFilter() {
    this.params.filterChangedCallback();
  }
}
